<div class="bvdc-header">
  <span class="bvdc-title">Add Virtual Debit Card</span>
  <button
    class="close-button"
    [mat-dialog-close]="undefined"
    type="button"
    tabindex="-1"
    mat-icon-button
    aria-label="Close"
  >
    <mat-icon class="notranslate">clear</mat-icon>
  </button>
</div>
<ng-container *ngIf="data.step === CreateUnitCardStep.FillDetails">
  <terra-unit-card-holder-form
    [businessCardDraft]="data.businessCard"
  ></terra-unit-card-holder-form>
</ng-container>

<ng-container
  *ngIf="data.step === CreateUnitCardStep.Created && data.businessCard"
>
  <mat-dialog-content>
    <div class="unit-card-created">
      <terra-unit-card
        [cardStatus]="data.businessCard.cardStatus"
        [holderFullName]="data.businessCard.fullName"
        [cardNumber]="data.businessCard.last4Digits"
        [exp]="data.businessCard.expirationDate"
      ></terra-unit-card>
      <h3 class="unit-card-created-title">Your Debit Card is Now Active!</h3>
      <div class="unit-card-created-sub-title">
        <p>
          <span class="unit-card-created-sub-title-bold">Fully Protected</span>
          - Your card details are encrypted and hidden
        </p>
        <p>
          <span class="unit-card-created-sub-title-bold">View Anytime</span> -
          Reveal your card details in the card management section when you need
          them
        </p>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="button" mat-flat-button mat-dialog-close>
      I'll do it later
    </button>
    <button
      type="button"
      class="finish-btn"
      mat-flat-button
      mat-dialog-close="true"
      color="primary"
    >
      Set PIN Code Now
    </button>
  </mat-dialog-actions>
</ng-container>
